import EmblaCarousel from "embla-carousel";

let emblaApi;

function initSlider() {
  const emblaNode = document.querySelector(".knowledge-base__items");

  emblaApi = EmblaCarousel(emblaNode, {
    loop: false,
    dragFree: false,
  });
}

class KnowledgeBaseClass {
  init() {
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 1270) {
        initSlider();
      }
    });

    if (window.innerWidth <= 1270) {
      initSlider();
    }
  }
}

export const KnowledgeBase = new KnowledgeBaseClass();
